//获取系统菜单
export const getAuthoritySys = (data) => {
    return {
        url: '/rest/ssys/getAuthoritySys',
        method: 'get',
        params: data,
        openMock:false, 
        mock:function(){
			Cookies.set('cssSessionId','1dd6d1b6f4624e4ce830408415681577');
            return {
                userId:"1dd6d1b6f4624e4ce830408415681577",
                sysCode:"20211110"    
            }  
        }
    }
}